import Chapters from './pages/Chapters';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import PublicHeader from './components/PublicHeader';
import Footer from './components/Footer';
import Home from './pages/Home';
import Signup from './pages/Signup';
import About from './pages/About';
import ConstitutionalBylaws from './pages/ConstitutionalBylaws';
import History from './pages/History';
import Directory from './pages/Directory';
import Events from './pages/Events';
import Donate from './pages/Donate';
import Profile from './pages/Profile';
import EditProfile from './pages/EditProfile';
import Settings from './pages/Settings';
import Updates from './pages/Updates';
import Contact from './pages/Contact';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import { features } from './config/features';

// Public routes receive PublicHeader (no bell/avatar) and the shared Footer.
// Member-only routes (/profile, /settings, /edit-profile, /signup) manage
// their own header via MemberHeader and are excluded here.
const PUBLIC_PATHS = ['/', '/history', '/constitutional-bylaws', '/events', '/updates', '/directory', '/contact', '/login'];

function Layout() {
  const location = useLocation();

  const isPublicRoute = PUBLIC_PATHS.includes(location.pathname);

  return (
    <div className="flex flex-col min-h-screen">
      {/* Render shared public header once for all public pages */}
      {isPublicRoute && <PublicHeader variant={location.pathname === '/' ? 'transparent' : 'solid'} />}

      <div className="flex-grow">
        <Routes>
          {/* Public pages — header provided by Layout above */}
          <Route path="/" element={<Home />} />
          <Route path="/history" element={<History />} />
          <Route path="/constitutional-bylaws" element={<ConstitutionalBylaws />} />
          <Route path="/events" element={<Events />} />
          <Route path="/updates" element={<Updates />} />
          <Route path="/contact" element={<Contact />} />

          {/* Feature-gated pages — manage their own header */}
          <Route
            path="/chapters"
            element={features.chaptersPage ? <Chapters /> : <NotFound />}
          />
          <Route
            path="/chapters/:id"
            element={features.chaptersPage ? <Chapters /> : <NotFound />}
          />
          <Route
            path="/signup"
            element={features.joinNow ? <Signup /> : <NotFound />}
          />
          <Route
            path="/login"
            element={<Login />}
          />
          <Route
            path="/directory"
            element={features.directory ? <Directory /> : <NotFound />}
          />
          <Route
            path="/donate"
            element={features.giveBack ? <Donate /> : <NotFound />}
          />

          {/* Member-only / internal pages — manage their own header */}
          <Route path="/about" element={<About />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/edit-profile" element={<EditProfile />} />
          <Route path="/settings" element={<Settings />} />

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>

      {/* Footer on all public pages */}
      {isPublicRoute && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;